import React, { useState, useEffect } from 'react';
import { Form, Button, Spinner, Alert } from 'react-bootstrap';
import api from '../api';

export default function RewardPolicy() {
  const [policy, setPolicy] = useState({ dailyRewardCount: '', rewardAmount: '', resetTime: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    async function load() {
      try {
        const res = await api.get('/api/admin/rewardPolicy');
        // 合并默认值，防止 undefined
        setPolicy({
          dailyRewardCount: res.data.dailyRewardCount ?? '',
          rewardAmount: res.data.rewardAmount ?? '',
          resetTime: res.data.resetTime ?? ''
        });
      } catch (e) {
        setError(e.response?.data?.message || '读取策略失败');
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  const handleChange = e => {
    const { name, value } = e.target;
    setPolicy(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setSaving(true);
    setError('');
    setSuccess('');
    try {
      const body = {
        dailyRewardCount: Number(policy.dailyRewardCount),
        rewardAmount: Number(policy.rewardAmount),
        resetTime: policy.resetTime
      };
      await api.put('/api/admin/rewardPolicy', body);
      setSuccess('保存成功');
    } catch (e) {
      setError(e.response?.data?.message || '保存失败');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <Spinner animation="border" />;

  return (
    <div>
      <h2>银币派奖策略</h2>
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="dailyRewardCount">
          <Form.Label>每日派发次数</Form.Label>
          <Form.Control
            type="number"
            name="dailyRewardCount"
            value={policy.dailyRewardCount ?? ''}
            onChange={handleChange}
            min={0}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="rewardAmount">
          <Form.Label>每次派发银币数</Form.Label>
          <Form.Control
            type="number"
            name="rewardAmount"
            value={policy.rewardAmount ?? ''}
            onChange={handleChange}
            min={0}
            required
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="resetTime">
          <Form.Label>重置时间</Form.Label>
          <Form.Control
            type="time"
            name="resetTime"
            value={policy.resetTime ?? ''}
            onChange={handleChange}
            required
          />
        </Form.Group>
        <Button type="submit" disabled={saving} variant="primary">
          {saving ? '保存中...' : '保存'}
        </Button>
      </Form>
    </div>
  );
}
